import type { Resource } from "@ferrivia/i18n";
import fi from "./locales/fi.json";
import en from "./locales/en.json";

export const chatUiResources: Resource = {
  fi: { chat: fi },
  en: { chat: en },
};
